const popup = {
  'all-in-one': 'popup.all-in-one',
  'digital-try-in': 'popup.digital-try-in',
  'shade-guide-ai': 'popup.shade-guide-ai',
  'staining-studio-crown': 'popup.staining-studio-crown',
  'staining-studio-gingiva-staining': 'popup.staining-studio-gingiva-staining',
  'staining-studio-stump-shade': 'popup.staining-studio-stump-shade',
  'full-layering-framework': 'popup.full-layering-framework',
  'staining-studio-wash-bake': 'popup.staining-studio-wash-bake',
  'micro-layering-material-advice': 'popup.micro-layering-material-advice',
  'full-monolithic-material-advice': 'popup.full-monolithic-material-advice',
  'full-layering-wash-bake': 'popup.full-layering-wash-bake',
  'pfm-crown-opaquer-staining': 'popup.pfm-crown-opaquer-staining',
  'pfm-crown-dentin': 'popup.pfm-crown-dentin',
  'full-layering-dentin': 'popup.full-layering-dentin',
  'full-layering-internal-effects': 'popup.full-layering-internal-effects',
  'micro-layering-internal-effects': 'popup.micro-layering-internal-effects',
  'pfm-crown-internal-effects': 'popup.pfm-crown-internal-effects',
  'full-layering-staining-corrections':
    'popup.full-layering-staining-corrections',
  'micro-layering-staining': 'popup.micro-layering-staining',
  'full-monolithic-staining': 'popup.full-monolithic-staining',
  'pfm-crown-staining-corrections': 'popup.pfm-crown-staining-corrections',
  'gingiva-staining': 'popup.gingiva-staining',
  'full-layering-enamel': 'popup.full-layering-enamel',
  'micro-layering-enamel': 'popup.micro-layering-enamel',
  'pfm-crown-enamel': 'popup.pfm-crown-enamel',
  'gingiva-ceramic': 'popup.gingiva-ceramic',
  'pfm-crown-opaquer': 'popup.pfm-crown-opaquer',
  'model-making-resin-recipe': 'popup.model-making-resin-recipe',
  'model-making-3d-printed-model-staining':
    'popup.model-making-3d-printed-model-staining',
  'matisse-lite-staining-studio': 'popup.matisse-lite-staining-studio',
  'matisse-lite-dentin_enamel': 'popup.matisse-lite-dentin_enamel',
}

export default popup
